/**
 * Parse Query String
 *
 * a function to parse a given query string and return a object with key value pairs
 *
 * @param {string} urlQuery
 * @returns {Object.<string, string>}
 */
export const parseQueryString = (urlQuery: string): Record<string, string> => {
  if (urlQuery && urlQuery.length > 0) {
    return decodeURIComponent(urlQuery)
      .replace(/^\?/g, '')
      .split('&')
      .reduce(
        (acc, query) => {
          const [key, value] = query.split('=');

          if (key) {
            acc[key] = decodeURIComponent(value);
          }

          return acc;
        },
        {} as Record<string, string>,
      );
  }

  return {};
};
